import {
  ryanairConditionLinksForBEFR,
  ryanairConditionLinksForBENL,
  ryanairConditionLinksForDK,
  ryanairConditionLinksForEN,
  ryanairConditionLinksForFR,
  ryanairConditionLinksForNL,
  ryanairConditionLinksForSE,
} from '@/scopes/checkout/domain/policies/ryanairConditionLinks'
import { SiteName } from '@/scopes/common/domain/types'

export function getRyanairTermsAndConditionsLinks(siteName: SiteName) {
  const CONDITIONS_LINKS: Partial<Record<SiteName, Record<string, string>>> = {
    sunwebnl: ryanairConditionLinksForNL,
    sunwebbenl: ryanairConditionLinksForBENL,
    sunwebbefr: ryanairConditionLinksForBEFR,
    sunwebuk: ryanairConditionLinksForEN,
    sunwebse: ryanairConditionLinksForSE,
    sunwebfr: ryanairConditionLinksForFR,
    sunwebdk: ryanairConditionLinksForDK,
    elizanl: ryanairConditionLinksForNL,
    elizabe: ryanairConditionLinksForBENL,
  }

  return CONDITIONS_LINKS[siteName] ?? null
}

const SITE_NAMES_WITHOUT_MOBILE_PHONE_HELP_TEXT_ON_PERSONAL_DETAILS_STEP = new Set<SiteName>(['sunwebdk', 'sunwebse'])

export function shouldShowHelpTextForMobilePhoneInputOnPersonalDetailsStep(siteName: SiteName) {
  return !SITE_NAMES_WITHOUT_MOBILE_PHONE_HELP_TEXT_ON_PERSONAL_DETAILS_STEP.has(siteName)
}
